import type { WorkHistoryDailyStat } from "./useWorkHistorySummaryQuery";

/**
 * Work History에 표시할 날짜. Desktop panel과 mobile sheet 모두 이 로직으로 정해서
 * breakpoint별로 선택 상태가 갈라지지 않게 한다.
 *
 * - 사용자가 고른 날짜가 결과에 있으면 그 날짜를 쓴다.
 * - 없으면 `autoSelectLatest`일 때만(항상 보이는 desktop panel) 실제 일지가 있는 가장 최근 날짜를 고른다.
 *   mobile은 날짜가 정해지면 sheet가 열리므로 사용자가 고르기 전에는 선택하지 않는다.
 * - 실제 일지가 하나도 없으면 선택하지 않는다 (빈 상태).
 */
export function resolveSelectedWorkHistoryDate(
  userSelectedDate: string | null,
  dailyStats: WorkHistoryDailyStat[],
  { autoSelectLatest }: { autoSelectLatest: boolean },
): string | null {
  if (dailyStats.length === 0) return null;

  if (userSelectedDate !== null && dailyStats.some((stat) => stat.date === userSelectedDate)) {
    return userSelectedDate;
  }

  return autoSelectLatest ? findLatestLoggedDate(dailyStats) : null;
}

/** daily_log_id가 있는(실제 일지가 존재하는) 날짜 중 가장 최근 날짜. 없으면 null. */
function findLatestLoggedDate(dailyStats: WorkHistoryDailyStat[]): string | null {
  let latest: string | null = null;
  for (const stat of dailyStats) {
    if (stat.daily_log_id === null) continue;
    if (latest === null || stat.date > latest) {
      latest = stat.date;
    }
  }
  return latest;
}
